export default "__VITE_ASSET__bdb41ba5__"